import apiClient from '../client/api-client'
import axios from 'axios'
import { baseURL } from 'config'
const unifiedSearchService = 'unified-search-service'
const detail = 'detail'

export default {
  /**
   * Fetches details of each entity by id
   */
  async fetchEntityDetails(payload) {
    const authToken = localStorage.getItem('default_auth_token')
    if (!authToken) {
      let headers = {
        Authorization: `Bearer ${payload.token}`,
        'Content-Type': 'application/json'
      }
      try {
        const { data } = await axios.get(
          `${baseURL}/${unifiedSearchService}/${detail}/${payload.path}/${payload.id}`,
          {
            headers: headers
          }
        )
        return data
      } catch (err) {
        throw new Error(err)
      }
    } else {
      try {
        const { data } = await apiClient.get(
          `${unifiedSearchService}/${detail}/${payload.path}/${payload.id}`
        )
        return data
      } catch (err) {
        throw new Error(err)
      }
    }
  }
}
